export default __webpack_public_path__ + "static/media/about-cl-1.8abad42b.jpg";